@if (copyConfigFinalised$ | async) {
  <eco-job-status-placeholder
    title="Tenant Configuration Successfully Exported!"
    subtitle="Configuration for Tenant {{ (copyFromTenant$ | async)?.Value }} was successfully exported and stored."
    >
    <div class="steps-container">
      <div class="step">
        <div>
          <div class="step-number">1</div>
        </div>
        <div class="step-content">
          <h1>Copy Export Id</h1>
          <p>Copy this <b>Export Id</b> and do not change or refresh the page until you haven't stored this unique identifier.
        Otherwise you won't be able to find your exported configuration and you will have to start the process all over again.</p>
        <div class="copy-container">
          <div>Export Id:</div>
          <input #exportIdInput
            (click)="selectText()"
            [value]="copyConfigJobId$ | async"
            class="copy-input">
            <button (click)="copyText()" mat-raised-button color="accent">{{ copyButtonText }} <mat-icon>content_copy</mat-icon></button>
          </div>
        </div>
      </div>
      <div class="step">
        <div>
          <div class="step-number">2</div>
        </div>
        <div class="step-content">
          <h1>Arrange Configuration movement</h1>
          <p>Ask your manager how to make a request for moving your exported Configuration to the desired environment
            where your target tenant is placed. Make sure to include the <b>Export Id</b> from above in the email.</p>
          </div>
        </div>
        <div class="step">
          <div>
            <div class="step-number">3</div>
          </div>
          <div class="step-content">
            <h1>Import Configuration</h1>
            <p>After CloudOps have moved the exported data in the final environment you will get an <b>Import Id</b>.
            Go to <b>Copy Config</b> page, select <b>Import Only</b> option from the top and paste the Import Id in there
            in order to finish the Copy Config process.
          </p>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button mat-raised-button color="accent" (click)="copyAnotherTenant()">Copy Config from another tenant</button>
    </div>
  </eco-job-status-placeholder>
} @else {
  <form #copyConfigForm="ngForm" data-qa-id="copyconfig-export-only-form">
    <div class="row selectors-container">
      <div>
        <span class="title">Copy From:</span>
        <mat-select name="copyFromTenant" placeholder="Select copy from tenant" class="mat-primary"
          [(ngModel)]="copyFromTenantValue" (selectionChange)="changeCopyFrom()">
        @for (tenant of getCopyFromTenantOptions(); track tenant) {
          <mat-option [value]="tenant.Value">
            {{ tenant.Value }}
          </mat-option>
        }
      </mat-select>
    </div>
    <div class="environment">
      <span class="title">Environment:</span>
      {{ copyFromEnvironment$ | async }}
    </div>
  </div>
  <div class="row">
    <div class="control-label">Copy Options:</div>
    @for (category of getOptionsCategories(); track category) {
      <div class="category-container">
        <div class="category-header">
          <span class="text-with-tooltip">
            <span class="category-name">{{ category.name }}</span>
            <mat-icon [matTooltip]="category.tooltip" matTooltipClass="multiline-tooltip"
            class="tooltip">info_outline</mat-icon>
          </span>
          <mat-checkbox class="select-all-button" [disabled]="!isSelectAllButtonAvailable(category)"
            [checked]="isAllOptionsChecked(category)" [indeterminate]="isSomeOptionsChecked(category)"
            (change)="setAllOptions(category, $event.checked)">
            Select All
          </mat-checkbox>
        </div>
        <div class="options-container">
          @for (option of category.options; track option.Identifier) {
            <div class="option text-with-tooltip">
              <mat-checkbox [(ngModel)]="option.Checked" [name]="option.Text" [disabled]="!option.Editable">
                {{ option.Text }}
              </mat-checkbox>
              @if (option.Tooltip) {
                <mat-icon [matTooltip]="option.Tooltip" matTooltipClass="multiline-tooltip"
                class="tooltip">info_outline</mat-icon>
              }
            </div>
          }
          @if (!categoryHasOptions(category)) {
            <eco-no-data-placeholder
            [text]="'No options available\nPlease select a destination tenant'"></eco-no-data-placeholder>
          }
        </div>
      </div>
    }
  </div>
  <div class="row">
    <button mat-raised-button [disabled]="!isCopyConfigAvailable()" class="mat-accent" type="submit"
      (click)="copyConfigConfirm()">
      Copy Configuration Export Only
    </button>
  </div>
</form>
}
